<template>
  <section>
    <gs-header title="Sửa vùng miền"
      :breadcrumbs="[
        {title: 'Quản lý vùng miền', route: {name: 'region'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localRegion" :rules="rules" ref="createRegionForm" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitRegion('createRegionForm')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localRegion.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tên viết tắt" prop="short_name">
              <el-input v-model="localRegion.short_name" placeholder="Tên viết tắt"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Tỉnh thành thuộc vùng miền">
              <el-select
                class="width-100"
                v-model="localRegion.cities"
                multiple
                filterable
                placeholder="Chon tỉnh thành"
                >
                <el-option
                  v-for="city in cities"
                  :key="city.id"
                  :label="city.name"
                  :value="city.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { getRegion, editRegion } from 'src/api/regions'
import { head, forEach, findIndex } from 'lodash'
import mixins from './mixins'
export default {

  name: 'EditRegion',
  mixins: [mixins],
  data () {
    return {}
  },
  methods: {
    validateBeforeSubmitRegion () {
      this.submitting = true
      this.toggleLoadding()
      this.$refs.createRegionForm.validate(valid => {
        if (valid) {
          this.changedData = false
          editRegion(this.localRegion, {id: this.$route.params.id}).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Cập nhật thành công',
                  body: 'Sửa vùng miền thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'region'}, 'regions')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    },
    selectCity (city) {
      if (findIndex(this.localRegion.cities, {id: city.id}) < 0) {
        this.localRegion.cities.push(city.id)
      }
    }
  },
  mounted () {
    getRegion({id: this.$route.params.id, params: {include: 'cities'}}).then(response => {
      switch (response.code) {
        case 200:
          this.localRegion.name = response.data.name
          this.localRegion.short_name = response.data.short_name
          if (response.data.cities.data.length) {
            this.localRegion.cities = []
            forEach(response.data.cities.data, (city) => {
              this.selectCity(city)
            })
          }
          setTimeout(() => {
            this.watching = true
          }, 100)
          break
        case 404:
          this.$store.dispatch('showNotify', {
            title: 'Không tìm thấy tài nguyên',
            body: 'Vùng miền không tồn tại trên hệ thống',
            type: 'warning'
          }, {root: true})
          this.$route.push({name: 'region'})
          break
        default:
      }
    })
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// EditRegion.vue?4af564d6